<template>
  <div id="app">
    <HeaderView />
    <router-view />
    <FooterView />
  </div>
</template>

<script>
import FooterView from './components/FooterView.vue';
import HeaderView from './components/HeaderView.vue';

export default {
  name: 'App',
  components: {

    FooterView,
    HeaderView

  }
}
</script>

<style>

</style>
